// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17WOK","productName":"Table_productName__2UcI-"};